// ABOUTME: Hook that resolves active company-specific overrides based on user context.
// ABOUTME: Filters menu items and routes by isActive predicates for the current company.

import { useAuth } from '@src/hooks';
import { SettingsContext } from '@src/modules/setting/SettingsContext';
import { useContext, useMemo } from 'react';

import { companyOverrides } from '../registry';
import { CompanyMenuItem, CompanyOverrideContext, CompanyRoute } from '../types';

interface UseCompanyOverridesResult {
    menuItems: CompanyMenuItem[];
    routes: CompanyRoute[];
    defaultRoute: string | null;
}

export function useCompanyOverrides(): UseCompanyOverridesResult {
    const { hasUserRole, sessionData } = useAuth();
    const settings = useContext(SettingsContext);
    const company = sessionData?.attributes?.company ?? '';

    return useMemo(() => {
        const override = companyOverrides.find(o => o.companyIds.includes(company));
        if (!override) {
            return { menuItems: [], routes: [], defaultRoute: null };
        }

        const ctx: CompanyOverrideContext = { company, hasUserRole, settings };

        const menuItems = override.menuItems
            .filter(item => item.isActive(ctx))
            .sort((a, b) => a.order - b.order);

        const routes = override.routes.filter(route => route.isActive(ctx));

        const defaultRoute = override.getDefaultRoute?.(ctx) ?? null;

        return { menuItems, routes, defaultRoute };
    }, [company, settings]);
}
